<template>
  <div>
    <top-bar heading="Sign Off Forms"></top-bar>
    <div class="container-fluid mt-3">
      <b-card heading="Signoff Forms">
        <table class="table table-responsive-md table-striped">
          <thead>
            <tr>
              <th>Student</th>
              <th>Supervisor</th>
              <th>Assessor</th>
              <th>Form</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="form in forms.data" :key="form.id">
              <td>{{ form.student ? form.student.name_full : '' }}</td>
              <td>{{ form.supervisor ? form.supervisor.name_full : '' }}</td>
              <td>{{ form.assessor ? form.assessor.name_full : '' }}</td>
              <td>{{ form.form_name }}</td>
              <td>{{ form.updated_at }}</td>
              <td>
                <router-link :to="'/signoff_forms/' + form.id" class="btn btn-primary">
                  <i class="fas fa-pencil"></i> Fill Form
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignoffFormsList',
  data () {
    return {};
  },
  methods: {},
  computed: {
    forms () {
      return this.$store.state.mySignoffForms;
    }
  },
  mounted () {},
  metaInfo: {
    title: 'Sign Off Forms'
  }
};
</script>
